import { TitleButtonDivider } from '@/common/buttons/TitleButtonDivider';
import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { RowIcon } from '@/common/entityFramework/entityPerspective/support/RowIcon';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useRef } from 'react';
import { TheraSelect } from '../../theraSelect/TheraSelect';

export const AbvChbkPymtPerspective = () => {
  const entityPerspectiveRef = useRef();
  const theraSelectRef = useRef();

  const views = [
    {
      name: 'Payments',
      dims: ['PAID_PERIOD', 'CHANNEL', 'PROD', 'EARNED_PERIOD'],
      kpis: ['PYMT_AMT', 'PYMT_ADJ', 'TOTAL_PYMT'],
      numFrozenDims: 1,
      dimToPeriodicities: {
        PAID_PERIOD: ['LIFETIME', 'YEAR', 'QTR', 'MON'],
        EARNED_PERIOD: ['YEAR', 'QTR'],
      },
    },
    {
      name: 'Processing Days',
      dims: ['PAID_PERIOD', 'PROD'],
      kpis: [
        'PYMT_AMT',
        'TOTAL_DAYS',
        'TOTAL_RECORDS',
        'BEFORE90_DAYS_PYMT_AMT',
        'BEFORE90_DAYS_TOTAL_DAYS',
        'BEFORE90_DAYS_TOTAL_RECORDS',
      ],
      numFrozenDims: 1,
      dimToPeriodicities: {
        PAID_PERIOD: ['LIFETIME', 'YEAR', 'QTR', 'MON'],
        EARNED_PERIOD: ['YEAR', 'QTR'],
      },
    },
  ];

  const rowIconsFn = (data) => {
    let rowIcons = [];

    // Closed
    if (data.closed) {
      rowIcons.push(<RowIcon key="closed" icon={fas.faCheckCircle} color="green" toolTip="Period is closed" />);
    }

    return rowIcons;
  };

  const getContextMenuItems = (params) => {
    let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

    let pymtSubMenu = [
      {
        name: 'Payment Amounts',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'PYMT_AMT', 'Payment Amounts'),
        icon: fas.faListUl,
      },
      {
        name: 'Pivot Payment Amounts',
        action: () => entityPerspectiveRef.current.navigateToPivot(params, 'PYMT_AMT', 'Payment Amounts'),
        icon: fas.faTableColumns,
      },
    ];

    contextMenus.push({
      name: 'Total Model N Transaction Details',
      subMenu: pymtSubMenu,
      icon: fas.faListUl,
    });

    if (entityPerspectiveRef.current.activeView.name === 'Processing Days') {
      let after90DaysSubMenu = [
        {
          name: 'Payment Amounts',
          action: () =>
            entityPerspectiveRef.current.navigateToViewer(
              params,
              'PYMT_AMT',
              'Payment Amounts',
              'BEFORE90_DAYS_PYMT_AMT_VIEWER_PLUGIN',
            ),
          icon: fas.faListUl,
        },
        {
          name: 'Pivot Payment Amounts',
          action: () =>
            entityPerspectiveRef.current.navigateToPivot(
              params,
              'PYMT_AMT',
              'Payment Amounts',
              'BEFORE90_DAYS_PYMT_AMT_VIEWER_PLUGIN',
            ),
          icon: fas.faTableColumns,
        },
      ];

      contextMenus.push({
        name: 'Before 90 Days Transaction Details',
        subMenu: after90DaysSubMenu,
        icon: fas.faListUl,
      });
    } else {
      let pymtAdjSubMenu = [
        {
          name: 'Payment Adjustments',
          action: () => entityPerspectiveRef.current.navigateToViewer(params, 'PYMT_ADJ', 'Payment Adjustments'),
          icon: fas.faListUl,
        },
        {
          name: 'Pivot Payment Adjustments',
          action: () => entityPerspectiveRef.current.navigateToPivot(params, 'PYMT_ADJ', 'Payment Adjustments'),
          icon: fas.faTableColumns,
        },
      ];
      contextMenus.push({
        name: 'Payment Adjustment Details',
        subMenu: pymtAdjSubMenu,
        icon: fas.faListUl,
      });
    }

    return contextMenus;
  };

  const handleViewReset = useCallback(() => {
    theraSelectRef.current.reset();
  }, []);

  const events = {
    onDimFilterChange: ({ dimCode }) => {
      if (dimCode === 'PROD') {
        theraSelectRef.current.reset();
      }
    },
  };
  const augButtons = (buttons) => {
    buttons.push(
      <TheraSelect entityPerspectiveRef={entityPerspectiveRef} ref={theraSelectRef} />,
      <TitleButtonDivider key="filterButtonDivider" />,
    );
  };

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      views={views}
      augButtons={augButtons}
      onViewReset={handleViewReset}
      events={events}
      rowIconsFn={rowIconsFn}
      gridOptions={{
        getContextMenuItems,
      }}
    />
  );
};
